import React from 'react';
import Img from 'gatsby-image';
import style from './pressAbout.module.css';
const PressAbout = ({ section }) => {
  return (
    <main className={style.aboutWrapper}>
      <section className={style.aboutFirstSection}>
        <p className="bodytext-1-mega">
          Coworkers <span>10+</span>
          Founded in <span>2020</span>
        </p>
        <p>We’are located in</p>
        <h4>Stockholm, Sweden</h4>
      </section>
      <section className={style.aboutSecondSection}>
        <div>
          <Img fluid={section.images[0].fluid} alt={'App promo'} />
        </div>
        <div>
          <h6>{section.overline}</h6>
          <h3>{section.title}</h3>
          <p>
            {section.body1}
            <br /> <br />
            {section.body2}
          </p>
        </div>
      </section>
    </main>
  );
};
export default PressAbout;
